var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.1563,
    height: 18.67,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8988 8.68814C13.8882 9.51567 14.6473 9.97744 15.2191 10.252C15.8066 10.5337 16.004 10.7144 16.0017 10.9663C15.9973 11.3518 15.533 11.522 15.0986 11.5286C14.3406 11.5402 13.8999 11.3269 13.5496 11.1657L13.2765 12.4246C13.628 12.5842 14.2789 12.7234 14.9539 12.7295C16.5383 12.7295 17.5748 11.9589 17.5804 10.7641C17.5866 9.24771 15.4518 9.16378 15.4664 8.486C15.4714 8.28049 15.6704 8.06117 16.1065 8.00541C16.3224 7.97724 16.9183 7.95568 17.5939 8.26223L17.8591 7.04422C17.4958 6.91387 17.0288 6.78905 16.4474 6.78905C14.9561 6.78905 13.9073 7.57016 13.8988 8.68814ZM20.4071 6.89397C20.1178 6.89397 19.874 7.06025 19.7652 7.31542L17.502 12.64H19.0852L19.4002 11.7821H21.3349L21.5177 12.64H22.9131L21.6954 6.89397H20.4071ZM20.6286 8.44619L21.0855 10.6039H19.8342L20.6286 8.44619ZM11.9792 6.89404L10.7313 12.64H12.24L13.4873 6.8939H11.9792M9.74737 6.8939L8.17705 10.805L7.54184 7.47955C7.4673 7.10832 7.17296 6.89397 6.84609 6.89397H4.27912L4.24316 7.06082C4.77015 7.1735 5.3689 7.35523 5.73166 7.54968C5.95365 7.66846 6.01696 7.7723 6.08988 8.05456L7.293 12.64H8.88731L11.3316 6.89397L9.74737 6.8939Z",
    fill: "url(#paint0_linear_3723_2733)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3723_2733",
    x1: 862.576,
    y1: 24.646,
    x2: 879.519,
    y2: -585.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4f5e7e12f2ea039ecd1eb287cdb52efa.svg";
export { ForwardRef as ReactComponent };